var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1000"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.order ? _c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("구매내역")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.order.purchases,
      "headers": _vm.purchaseHeaders,
      "loading": _vm.loading,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(_vm.order.purchases.indexOf(item) + 1))];
      }
    }, {
      key: "item.product",
      fn: function fn(_ref3) {
        var _item$product, _item$product2, _item$product3;

        var item = _ref3.item;
        return [_c('router-link', {
          attrs: {
            "to": "/dshop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.name))]), ((item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.optionalNames) || []).length ? _vm._l(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.optionalNames, function (val, index) {
          var _item$product4;

          return _c('div', {
            key: index
          }, [_vm._v(" " + _vm._s("".concat(val, " : ").concat(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.optionalValues[index])) + " ")]);
        }) : _vm._e()], 2)];
      }
    }, {
      key: "item.quantity",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(_vm._s(item.quantity) + "개")];
      }
    }], null, true)
  })], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }